import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bd4be04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "x-container" }
const _hoisted_3 = { class: "profile" }
const _hoisted_4 = { class: "profile__info --desktop" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "profile__info-title" }, "My profile", -1))
const _hoisted_6 = { class: "profile__content" }

import { Topline } from "@/components/topline";
import { Header } from "@/components/Header";
import ProfileCard from "@/components/ProfileCard/ProfileCard.vue";

import { useStore } from "vuex";
import { computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'profilePage',
  setup(__props) {

const store = useStore();
const user = computed(() => store.state.auth.user);

onMounted(async () => {
  if (user.value === null) {
    await store.dispatch("auth/getUserData");
  }
});
console.log(user);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Topline), null, {
      headline: _withCtx(() => [
        _createVNode(_unref(Header), {
          "avatar-url": _unref(user)?.avatar_url
        }, null, 8, ["avatar-url"])
      ]),
      content: _withCtx(() => [
        _createVNode(ProfileCard, {
          class: "profile__info-card profile__info-card--ipad --ipad",
          userInfo: {
            avatarUrl: _unref(user)?.avatar_url,
            login: _unref(user)?.login,
            repos: _unref(user)?.public_repos,
            following: _unref(user)?.following,
            name: _unref(user)?.name,
          }
        }, null, 8, ["userInfo"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(ProfileCard, {
            class: "profile__info-card",
            userInfo: {
              avatarUrl: _unref(user)?.avatar_url,
              login: _unref(user)?.login,
              repos: _unref(user)?.public_repos,
              following: _unref(user)?.following,
              name: _unref(user)?.name,
            }
          }, null, 8, ["userInfo"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}
}

})